// extracted by mini-css-extract-plugin
export default {"feature":"feature_feature__j6uWJ","name":"feature_name__aZ9nS","text":"feature_text__uab05"};